import { render, staticRenderFns } from "./Projetos.vue?vue&type=template&id=2c6c6ac5"
import script from "./Projetos.vue?vue&type=script&lang=js"
export * from "./Projetos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports